import Router from "./shared/Router";
import "./shared/App.css";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
